import "../assets/Note.css";
import { defineComponent as S, computed as r, openBlock as c, createElementBlock as P, normalizeStyle as O, useCssVars as U, ref as v, createBlock as k, Transition as X, withCtx as j, withDirectives as q, createElementVNode as h, unref as b, normalizeClass as H, createCommentVNode as A, Fragment as G, renderList as J, resolveDynamicComponent as C, mergeProps as Q, createVNode as W, vShow as Y, watch as Z, onUpdated as fe, onMounted as ve } from "vue";
import { d as w, e as B, a as $, b as D, A as L, f as he } from "./maps.ChaVcqWI.js";
import { u as ee, b as _e } from "./index.AJuLibkw.js";
import { _ as te } from "./Icon.vue_vue_type_style_index_0_lang.DyGK7-dE.js";
import { _ as oe } from "./XClose.vue_vue_type_style_index_0_lang.DycEamnE.js";
import { o as N, n as ye, u as ge } from "./useStore.BHVfM1RP.js";
import { a as Te, _ as be, b as we, c as ke } from "./Text.vue_vue_type_style_index_0_lang.-ztwnf54.js";
import { _ as Me } from "./_plugin-vue_export-helper.CHgC5LLL.js";
import { p as z } from "./parseToolData.o66wWUUl.js";
function x(m, a = w.UpperLeft, e = !0) {
  let o = m;
  switch (a) {
    case w.Top:
      o += "-from-top";
      break;
    case w.Bottom:
      o += "-from-bottom";
      break;
    default:
      o += `-from-${a.slice(-1) === "L" ? "left" : "right"}`;
      break;
  }
  return e || (o += "-no-bounce"), o;
}
const Le = ["innerHTML", "data-module-id"], Be = /* @__PURE__ */ S({
  __name: "Activity",
  props: {
    moduleProps: {}
  },
  setup(m) {
    const a = N(), e = m, o = r(
      () => a == null ? void 0 : a.literals.getActivityLiteral(
        e.moduleProps.textKey,
        a == null ? void 0 : a.extraData.tokens
      )
    ), f = r(() => Te(e.moduleProps.appearance, a == null ? void 0 : a.device));
    return (l, M) => (c(), P("div", {
      class: "thn--tool-activity",
      innerHTML: o.value,
      "data-module-id": l.moduleProps.id,
      style: O(f.value)
    }, null, 12, Le));
  }
}), ne = {
  [B.Paragraph]: be,
  [B.Activity]: Be,
  [B.Button]: we
}, Ge = [
  $.SlideIn
], De = ["data-position", "data-device", "data-builder-mode", "data-text-direction"], Se = { class: "thn--tool-note__content" }, Pe = {
  class: /* @__PURE__ */ H([
    "thn--tool-note__modules"
  ]),
  "data-add-module": !0
}, $e = { class: "thn--tool-note__modules__wrapper" }, F = /* @__PURE__ */ S({
  __name: "SlideIn",
  props: {
    tool: {},
    context: {},
    onHideLayout: {},
    iconProps: {},
    restModules: { default: () => [] },
    layout: {},
    hidden: { type: Boolean, default: !1 }
  },
  setup(m) {
    U((t) => ({
      "1327b338": o.value,
      "397c92bf": f.value
    }));
    const a = m, e = N(), o = r(() => e != null && e.rtl ? "none" : "12px"), f = r(() => e != null && e.rtl ? "12px" : "none"), l = v(), { height: M } = ee(l), g = r(() => {
      const { position: t } = a.tool.settings.devices[a.context.deviceViewport];
      return t ? x("fade", t) : void 0;
    }), { isSwiping: T, lengthX: n } = _e(l, {
      onSwipeEnd: () => {
        Math.abs(n.value) > 150 && (e == null || e.handlers.callHandler(L.Dismiss));
      }
    }), d = r(() => {
      const t = {};
      if (T.value && l.value) {
        const s = -l.value.getBoundingClientRect().width / 2 - n.value;
        t.transform = `translateX(${s}px)`, t.opacity = (100 - Math.abs(n.value / 3)) / 100;
      }
      return {
        ...t
      };
    });
    return (t, s) => (c(), k(X, {
      name: g.value,
      appear: "",
      onAfterLeave: t.onHideLayout
    }, {
      default: j(() => {
        var u;
        return [
          q(h("div", {
            class: "thn--tool thn--tool-note",
            ref_key: "rootDom",
            ref: l,
            style: O(d.value),
            "data-position": t.tool.settings.devices[t.context.deviceViewport].position,
            "data-device": t.context.deviceViewport,
            "data-builder-mode": t.context.builderMode,
            "data-text-direction": (u = b(e)) != null && u.rtl ? "rtl" : "ltr"
          }, [
            s[0] || (s[0] = h("div", { class: "thn--tool-note__back" }, null, -1)),
            h("div", Se, [
              t.iconProps ? (c(), k(te, {
                key: 0,
                class: H(["thn--tool-note__icon", [b(M) > 72 ? "icon-top" : "icon-center"]]),
                "data-module-id": t.iconProps.id,
                "data-module-special": !0,
                "module-props": t.iconProps
              }, null, 8, ["class", "data-module-id", "module-props"])) : A("", !0),
              h("div", Pe, [
                h("div", $e, [
                  (c(!0), P(G, null, J(t.restModules, (_, p) => (c(), k(C(b(ne)[_.moduleType]), Q({
                    class: "thn--tool-note-component",
                    key: p,
                    "tool-kind": b(D).Note,
                    ref_for: !0
                  }, {
                    moduleProps: _
                  }), null, 16, ["tool-kind"]))), 128))
                ])
              ])
            ]),
            W(oe)
          ], 12, De), [
            [Y, !t.hidden]
          ])
        ];
      }),
      _: 1
    }, 8, ["name", "onAfterLeave"]));
  }
}), xe = ["data-position", "data-content-alignment", "data-text-direction", "data-device"], He = { class: "thn--tool-note--bar__content" }, Ae = {
  class: /* @__PURE__ */ H([
    "thn--tool-note__modules"
  ]),
  "data-add-module": !0
}, Ce = { class: "thn--tool-note__modules__wrapper" }, Ne = /* @__PURE__ */ S({
  __name: "Bar",
  props: {
    hidden: { type: Boolean },
    iconProps: {},
    layout: {},
    restModules: {},
    context: {}
  },
  setup(m) {
    U((n) => ({
      "0fbd5903": M.value,
      "2009df80": g.value
    }));
    const a = m, e = N(), o = v(), { height: f } = ee(o);
    let l;
    const M = r(() => e != null && e.rtl ? "none" : "12px"), g = r(() => e != null && e.rtl ? "12px" : "none"), T = r(() => {
      var n;
      return ((n = a.layout) == null ? void 0 : n.position) === w.Bottom ? x("fade", w.Bottom, !1) : x("fade", w.Top, !1);
    });
    return Z(f, async (n, d) => {
      var t, s, u;
      ((t = a.layout) == null ? void 0 : t.position) === w.Top && (((s = a.layout) == null ? void 0 : s.behaviour) === he.Inline || !((u = a.layout) != null && u.behaviour)) && (d === 0 && n > 0 && (e == null || e.handlers.setDataValidator(
        L.TranslateDocumentBody,
        () => ({ y: f.value || 60 })
      ), l = await (e == null ? void 0 : e.handlers.callHandler(
        L.TranslateDocumentBody
      ))), d > 0 && n === 0 && (l && l(), e == null || e.handlers.setDataValidator(
        L.TranslateDocumentBody,
        () => ({ y: 0 })
      )));
    }), (n, d) => (c(), k(X, {
      name: T.value,
      appear: ""
    }, {
      default: j(() => {
        var t, s, u;
        return [
          q(h("div", {
            class: "thn--tool thn--tool-note--bar",
            ref_key: "rootDom",
            ref: o,
            "data-position": (t = n.layout) == null ? void 0 : t.position,
            "data-content-alignment": (s = n.layout) == null ? void 0 : s.contentAlignment,
            "data-text-direction": (u = b(e)) != null && u.rtl ? "rtl" : "ltr",
            "data-device": n.context.deviceViewport,
            "data-layout-direction": "horizontal"
          }, [
            h("div", He, [
              n.iconProps ? (c(), k(te, {
                key: 0,
                class: "thn--tool-note--bar__icon",
                "data-module-id": n.iconProps.id,
                "data-module-special": !0,
                "module-props": n.iconProps
              }, null, 8, ["data-module-id", "module-props"])) : A("", !0),
              h("div", Ae, [
                h("div", Ce, [
                  (c(!0), P(G, null, J(n.restModules, (_, p) => (c(), k(C(b(ne)[_.moduleType]), Q({
                    class: "thn--tool-note-component",
                    key: p,
                    "tool-kind": b(D).Note,
                    ref_for: !0
                  }, {
                    moduleProps: _
                  }), null, 16, ["tool-kind"]))), 128)),
                  W(oe)
                ])
              ])
            ])
          ], 8, xe), [
            [Y, !n.hidden]
          ])
        ];
      }),
      _: 1
    }, 8, ["name"]));
  }
}), Ve = /* @__PURE__ */ Me(Ne, [["__scopeId", "data-v-27adc56d"]]), Ee = ["data-device"], Je = /* @__PURE__ */ S({
  __name: "Note",
  props: {
    tool: {},
    context: {}
  },
  emits: [
    "hide",
    "hidden"
  ],
  setup(m, { expose: a, emit: e }) {
    const o = m, f = e, l = ye(z({
      ...o,
      toolKind: D.Note
    })), M = {
      [$.SlideIn]: F,
      [$.Bar]: Ve
    }, g = v(!1), T = v(!1), n = v(!1), d = v(null), t = r(() => T.value || n.value), s = v(0), u = v(0), _ = v(0);
    let p = null;
    const ae = r(() => (o.tool, {
      ...o.tool.settings.layout
    })), ie = r(() => o.tool.content.modules.find((i) => i.moduleType === B.Icon)), le = r(() => ke(o.tool.content.modules).filter(
      (y) => y.moduleType !== B.Icon
    )), V = r(() => {
      var y, I, R;
      if (!o.tool.settings.layout || !((I = (y = o.tool.settings) == null ? void 0 : y.layout) != null && I.type))
        return F;
      const i = (R = o.tool.settings.layout) == null ? void 0 : R.type;
      return M[i];
    });
    function se() {
      g.value = !1;
    }
    function E() {
      f("hide"), g.value = !0;
    }
    function re() {
      f("hidden");
    }
    fe(() => {
      ge(z({
        ...o,
        toolKind: D.Note
      }));
    });
    function de() {
      T.value = !0;
    }
    function ue(i) {
      var y;
      (y = d.value) != null && y.contains(i.relatedTarget) || (T.value = !1);
    }
    function ce() {
      n.value = !0;
    }
    function pe() {
      n.value = !1;
    }
    function K() {
      if (p && clearTimeout(p), s.value <= 0)
        return;
      _.value = Date.now();
      const i = s.value - u.value;
      p = setTimeout(() => {
        t.value || (l.handlers.callHandler(L.Hide), E());
      }, i);
    }
    function me() {
      if (p) {
        clearTimeout(p), p = null;
        const i = Date.now() - _.value;
        u.value += i;
      }
    }
    return ve(() => {
      d.value && (d.value.addEventListener("focusin", de), d.value.addEventListener("focusout", ue)), l.handlers.callHandler(L.Show), o.tool.settings.timing.pagetime && (s.value = Number(o.tool.settings.timing.pagetime) * 1e3, K());
    }), Z(t, (i) => {
      i ? me() : K();
    }), a({
      show: se,
      hide: E
    }), (i, y) => (c(), P("div", {
      class: "thn--tool-note-wrapper",
      ref_key: "noteRef",
      ref: d,
      "data-device": i.context.deviceViewport,
      onMouseenter: ce,
      onMouseleave: pe
    }, [
      V.value ? (c(), k(C(V.value), {
        key: 0,
        onAfterLeave: re,
        hidden: g.value,
        layout: ae.value,
        "icon-props": ie.value,
        "rest-modules": le.value,
        tool: i.tool,
        context: i.context
      }, null, 40, ["hidden", "layout", "icon-props", "rest-modules", "tool", "context"])) : A("", !0)
    ], 40, Ee));
  }
});
export {
  Je as _,
  Ge as d,
  x as g,
  ne as n
};
//# sourceMappingURL=Note.vue_vue_type_script_setup_true_lang.DltYdILr.js.map
